import { render } from "./pages-list.vue?vue&type=template&id=8afaf3c2"
import script from "./pages-list.vue?vue&type=script&lang=js"
export * from "./pages-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__